package br.com.texeratx.boardgametimeapp.ui.screens.players

data class PlayersFilter(
    val withNickname: Boolean = false,
    val withoutNickname: Boolean = false,
    val withPhoto: Boolean = false
) {
    fun hasActiveFilters(): Boolean = withNickname || withoutNickname || withPhoto
}
